import { startCase } from 'lodash'

import { Trans } from '@lingui/macro'
import Button from 'Root/App/Button'
import Title from 'Root/App/Title'
import {
  AUTHENTICATION_PROVIDERS,
  AUTHENTICATION_PROVIDERS_ICON_PATH,
} from 'lib/constants'
import Image from 'next/image'

interface SocialLoginButtonProps {
  provider: string
  onClick: () => void
  disabled?: boolean
}

const SocialLoginButton = ({
  provider,
  onClick = () => {},
  disabled = false,
}: SocialLoginButtonProps) => (
  <Button
    className="flex bg-gray-100 p-0 w-full"
    onClick={onClick}
    disabled={disabled}
  >
    <span className="flex justify-center items-center gap-3">
      <Image
        src={AUTHENTICATION_PROVIDERS_ICON_PATH[provider]}
        alt={`${AUTHENTICATION_PROVIDERS[provider]}-icon`}
        width={16}
        height={16}
      />
      <Title size="XS">
        <Trans>Continua con</Trans> {startCase(provider)}
      </Title>
    </span>
  </Button>
)

export default SocialLoginButton
